import React from 'react';
import ErrorHandler from 'components/ErrorHandler/ErrorHandler';
import { Loader } from 'components/Loader/Loader';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import Header from './Header';
import SidebarNew from 'modules/Layouts/SidebarNew/SidebarNew';
import routes from './routes';
import { Footer } from './Footer';
import ServerNotifications from 'components/ServerNotifications/ServerNotifications';
import FallBackHeader from 'components/ErrorBoundary/fallback/FallBackHeader/FallBackHeader';
import FallBackSidebar from 'components/ErrorBoundary/fallback/FallBackSidebar/FallBackSidebar';
import FallBackContent from 'components/ErrorBoundary/fallback/FallBackContent/FallBackContent';

interface IParams {
	hideSidebar?: boolean;
	hideHeaderNav?: boolean;
	hideHeaderProfile?: boolean;
	displayFooter?: boolean;
}

let defaultParams: IParams = {
	hideSidebar: false,
	hideHeaderNav: false,
	hideHeaderProfile: false,
	displayFooter: false,
};

let BaseLayout = <P extends Record<string, unknown>>(
	Component: React.ComponentType<P>,
	{ hideSidebar, hideHeaderNav, hideHeaderProfile, displayFooter }: IParams = defaultParams,
): React.ComponentType => {
	return class extends React.Component {
		render() {
			return (
				<div className="wrapper white-bg">
					<ErrorHandler />
					<Loader />
					<ErrorBoundary FallbackComponent={FallBackHeader}>
						<Header hideNav={hideHeaderNav} hideProfile={hideHeaderProfile} />
					</ErrorBoundary>
					<div className="mid">
						<ErrorBoundary FallbackComponent={FallBackSidebar}>
							<SidebarNew routes={routes} isHidden={hideSidebar} />
						</ErrorBoundary>
						<ErrorBoundary FallbackComponent={FallBackContent}>
							<main className="main">
								<Component {...(this.props as P)} />
							</main>
						</ErrorBoundary>
					</div>
					<Footer visible={displayFooter} />
					<ServerNotifications />
				</div>
			);
		}
	};
};

// const BaseLayout = (
// 	Component: () => any,
// 	{ hideSidebar, hideHeaderNav, hideHeaderProfile, displayFooter }: IParams = defaultParams,
// ) => {
// 	return (
// 		<div className="wrapper white-bg">
// 			<ErrorHandler />
// 			<Loader />
// 			<ErrorBoundary FallbackComponent={FallBackHeader}>
// 				<Header hideNav={hideHeaderNav} hideProfile={hideHeaderProfile} />
// 			</ErrorBoundary>
// 			<div className="mid">
// 				<ErrorBoundary FallbackComponent={FallBackSidebar}>
// 					<SidebarNew routes={routes} isHidden={hideSidebar} />
// 				</ErrorBoundary>
// 				<ErrorBoundary FallbackComponent={FallBackContent}>
// 					<main className="main">
// 						<Component />
// 					</main>
// 				</ErrorBoundary>
// 			</div>
// 			<Footer visible={displayFooter} />
// 		</div>
// 	);
// };

export default BaseLayout;
